import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c734db7c = () => interopDefault(import('../../../pages/old/App.vue' /* webpackChunkName: "" */))
const _64635a90 = () => interopDefault(import('../../../pages/old/home/home.vue' /* webpackChunkName: "" */))
const _0232b850 = () => interopDefault(import('../../../pages/old/ajkRank/xiaoqu/communityHot.vue' /* webpackChunkName: "" */))
const _528442bb = () => interopDefault(import('../../../pages/old/rank/borkerRank/borkerRank.vue' /* webpackChunkName: "" */))
const _42647112 = () => interopDefault(import('../../../pages/old/rank/storeRank/storeRank.vue' /* webpackChunkName: "" */))
const _7049a660 = () => interopDefault(import('../../../pages/old/ajkRank/qiangshou/index.vue' /* webpackChunkName: "" */))
const _7439796c = () => interopDefault(import('../../../pages/old/wakeAPP/wakeAPP.vue' /* webpackChunkName: "" */))
const _9f656858 = () => interopDefault(import('~/layouts/non-available.vue' /* webpackChunkName: "" */))
const _7e244030 = () => interopDefault(import('../../../pages/captcha-wangyi/index.vue' /* webpackChunkName: "" */))
const _5d63bbf2 = () => interopDefault(import('../../../pages/captcha-geetest/index.vue' /* webpackChunkName: "" */))
const _a37329b0 = () => interopDefault(import('../../../pages/trendency/index.vue' /* webpackChunkName: "" */))
const _1a794add = () => interopDefault(import('../../../pages/old/ajkRank/synList/synList.vue' /* webpackChunkName: "" */))
const _62dc279d = () => interopDefault(import('../../../pages/esf-package/index.vue' /* webpackChunkName: "" */))
const _20553b48 = () => interopDefault(import('../../../pages/map/index.vue' /* webpackChunkName: "" */))
const _3789475f = () => interopDefault(import('../../../pages/agreement/carrier/index.vue' /* webpackChunkName: "" */))
const _135fb100 = () => interopDefault(import('../../../pages/weak/miniProgram/index.vue' /* webpackChunkName: "" */))
const _144df6f5 = () => interopDefault(import('../../../pages/common-material/index.vue' /* webpackChunkName: "" */))
const _2ae49825 = () => interopDefault(import('../../../pages/samsung-download/index.vue' /* webpackChunkName: "" */))
const _c7056cc0 = () => interopDefault(import('../../../pages/app/download/index.vue' /* webpackChunkName: "" */))
const _6222cd93 = () => interopDefault(import('~/layouts/error.vue' /* webpackChunkName: "" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _c734db7c,
    alias: "/feapp",
    name: "App",
    children: [{
      path: ":city([a-z]+)/",
      component: _64635a90,
      name: "mHome"
    }, {
      path: "ershou-autorank/xiaoqu",
      component: _0232b850,
      name: "communityHot"
    }, {
      path: "ershou-autorank/broker",
      component: _528442bb,
      name: "brokerRank"
    }, {
      path: "ershou-autorank/store",
      component: _42647112,
      name: "storeRank"
    }, {
      path: "ershou-autorank/fangyuan/qiangshou/*",
      component: _7049a660,
      name: "qiangshou"
    }, {
      path: "ershou-autorank/fangyuan/pinzhi/*",
      component: _7049a660,
      name: "pinzhi"
    }, {
      path: "ershou-autorank/fangyuan/*",
      component: _7049a660,
      name: "houseRank"
    }, {
      path: "/wake/app",
      component: _7439796c,
      name: "wakeApp"
    }]
  }, {
    path: "/non-available",
    component: _9f656858,
    name: "Non Available"
  }, {
    path: "/esfcommon-captcha-wy",
    component: _7e244030,
    name: "captcha"
  }, {
    path: "/esfcommon-captcha-geetest",
    component: _5d63bbf2,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-wy",
    component: _7e244030,
    name: "captcha"
  }, {
    path: "/pcesfcommon-captcha-geetest",
    component: _5d63bbf2,
    name: "captcha"
  }, {
    path: "/:city([a-z]+)/trendency/",
    component: _a37329b0,
    name: "city-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)_:block_id(\\d+)/",
    component: _a37329b0,
    name: "block-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)/",
    component: _a37329b0,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/community/:comm_id",
    component: _a37329b0,
    name: "community-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_id(\\d+)-q-:shangquan_id(\\d+)/",
    component: _a37329b0,
    name: "shangquan-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)/",
    component: _a37329b0,
    name: "area-trendency"
  }, {
    path: "/:city([a-z]+)/trendency/:area_py(\\w+)-q-:shangquan_py(\\w+)/",
    component: _a37329b0,
    name: "shangquan-trendency"
  }, {
    path: "/ershou-autorank/synList",
    component: _1a794add,
    name: "syn-rankList"
  }, {
    path: "/feapp/ershou-autorank/synList",
    component: _1a794add,
    name: "syn-rankList-wb"
  }, {
    path: "/ershou-autorank/common",
    component: _62dc279d,
    name: "syn-com"
  }, {
    path: "/:city([a-z]+)/map/community",
    component: _20553b48,
    name: "map"
  }, {
    path: "/xiaoqu/([a-zA-Z0-9]+)/map/community",
    component: _20553b48,
    name: "mapwb"
  }, {
    path: "/agreement/carrier/:id",
    component: _3789475f,
    name: "agreement"
  }, {
    path: "/weak/miniProgram/esf",
    component: _135fb100,
    name: "weakMiniProgramESF"
  }, {
    path: "/clbCfg/common/material",
    component: _144df6f5,
    name: "commonMaterial"
  }, {
    path: "/clb_cfg/menu/materialtemplate/materialtemplate",
    component: _144df6f5,
    name: "commonMaterialPath"
  }, {
    path: "/agreement/samsungDownload",
    component: _2ae49825,
    name: "samsungDownload"
  }, {
    path: "/esfcommon/app/download",
    component: _c7056cc0,
    name: "appDownload"
  }, {
    path: "*",
    component: _6222cd93,
    name: "Not Found"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
